import React, { useState, memo, useRef, useEffect } from "react";
import { NodeResizer } from "reactflow";

const StickerNode = memo(function StickerNode({ data, selected, width: nodeWidth, height: nodeHeight }) {
  // 노드의 width/height 속성을 우선 사용, 없으면 data에서 가져옴
  const width = nodeWidth || data?.width || 200;
  const height = nodeHeight || data?.height || 200;
  const { 
    imageUrl = "",
    imageName = "스티커",
    opacity = 1,
    rotation = 0
  } = data || {};

  const [imageError, setImageError] = useState(false);
  const nodeRef = useRef(null);
  return (
    <>
    <div
      ref={nodeRef} 
      style={{ 
        width: `${width}px`, 
        height: `${height}px`,
        position: "relative",
        overflow: "visible",
        backgroundColor: "transparent",
        transform: `rotate(${rotation}deg)`,
        transformOrigin: 'center center',
        willChange: "transform",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden"
      }}
    >
      
      {/* 리사이저 - 이미지보다 위에 표시 */}
      <NodeResizer
        color="#000000"
        lineColor="#000000"
        lineStyle={{ stroke: "#000000", strokeWidth: 1, zIndex: 1000 }}
        handleStyle={{
          backgroundColor: "#ffffff",
          border: "4px solid #000000",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          boxSizing: "border-box",
          zIndex: 1001,
        }}
        isVisible={selected}
        minWidth={50}
        minHeight={50}
      />
      
      {/* 스티커 이미지 컨테이너 - overflow hidden으로 이미지만 클리핑 */}
      <div style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        position: "relative",
        zIndex: 1
      }}>
        {/* 스티커 이미지 표시 */}
        {imageUrl && !imageError ? (
          <img 
            src={imageUrl}
            alt={imageName}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain", // 비율 유지하며 리사이즈
              opacity: opacity,
              pointerEvents: "none",
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
              display: "block"
            }}
            onError={() => setImageError(true)}
            draggable={false}
          />
        ) : (
          <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#9ca3af",
            fontSize: "14px",
            backgroundColor: "rgba(0,0,0,0.05)",
            border: "1px dashed #ccc"
          }}>
            {imageError ? "스티커 로드 실패" : "스티커 없음"}
          </div>
        )}
      </div>
    </div>
    
  </>
  );
}, (prevProps, nextProps) => {
  // 커스텀 비교 함수: position, size, imageUrl, selected, selectedBy, showUserLabel이 같으면 re-render 방지
  return (
    prevProps.selected === nextProps.selected &&
    prevProps.width === nextProps.width &&
    prevProps.height === nextProps.height &&
    prevProps.data?.imageUrl === nextProps.data?.imageUrl &&
    prevProps.data?.opacity === nextProps.data?.opacity &&
    prevProps.data?.rotation === nextProps.data?.rotation &&
    prevProps.data?.width === nextProps.data?.width &&
    prevProps.data?.height === nextProps.data?.height &&
    prevProps.data?.selectedBy === nextProps.data?.selectedBy &&
    prevProps.data?.showUserLabel === nextProps.data?.showUserLabel
  );
});

export default StickerNode;

